import * as React from 'react';
import * as Styled from './styled';
import PulseLoader from 'react-spinners/PulseLoader';
import { BrandConfiguration } from '@toca.ui/config';
var brand = BrandConfiguration.GetBrandConfiguration();
var Loader = function (props) {
    var loading = props.loading, size = props.size, position = props.position, colour = props.colour;
    return (React.createElement(Styled.LoaderContainer, { position: position },
        React.createElement(PulseLoader, { sizeUnit: 'px', size: size === undefined ? 15 : size, color: colour ? colour : brand.brandStyling.loaderColor, loading: loading })));
};
export default Loader;
//# sourceMappingURL=Loader.js.map